import IconButton from "@mui/material/IconButton";
import ArrowBackIcon from "@mui/icons-material/ArrowBack.js";

export const BackButton = () => (document.referrer.indexOf("localhost") > 0 || document.referrer.indexOf("austin2step.com") > 0) ?
    <IconButton size={"small"} color={"primary"} onClick={() => window.history.back()}><ArrowBackIcon />Back</IconButton> :
    <IconButton size={"small"} color={"primary"} href={"/"}><ArrowBackIcon />Full Calendar</IconButton>